import { Component } from 'react';
import cx from 'classnames';
import Table from '../common/table';
import ValueBreakup from './valueBreakup';
import BlockHeader from './blockHeader';
import CheckedTips from '../common/checkedTips';
import SectionHeader from './sectionHeader';

import styles from '../../styles/plan/planSummary.scss';
import { returnsLabels, elssComparisonTable } from '../../constants';

/* Types */
interface PlanSummary {
  title: string;
  elssTable: boolean;
  returns: PlanSummaryReturns;
  investments: Investments;
}

interface Investments {
  title: string;
  data: Datum[];
}

interface Datum {
  investment: string;
  label: string;
  value: string;
}

interface PlanSummaryReturns {
  return3yr: number;
  return5yr: number;
}

interface PlanSummaryReasons {
  title: string;
  reasons: string[];
}

interface Props {
  data: PlanSummary;
  reasons: PlanSummaryReasons;
  showTitle?: boolean;
}

class PlanSummary extends Component<Props, {}> {
  private constructReturns = (returns: any) => {
    const headers = [{ value: 'Period' }, { value: 'Returns (per year)' }];
    const body = Object.keys(returns)
      .map(key =>
        returns[key]
          ? [{ value: returnsLabels[key] }, { value: `${returns[key]}%` }]
          : null
      )
      .filter((obj: any) => !!obj);
    return [headers, ...body];
  };

  public render() {
    const { reasons, data, showTitle = true } = this.props;
    const { investments, elssTable } = data;
    return (
      <div className={cx(styles['plan-summary'], 'summary-block')}>
        {showTitle ? <SectionHeader title="Plan Summary" golden /> : null}
        <div className={cx(styles['content'], !showTitle ? 'mt30' : null)}>
          <div className="row">
            <div className="large-6 medium-6 columns mb20">
              <BlockHeader text="Average returns of plans" />
              <Table data={this.constructReturns(data.returns) || []} />
            </div>
            <div className="large-6 medium-6 columns mb20">
              <BlockHeader text="This plan invests in" />
              <ValueBreakup data={investments.data} />
            </div>
            {elssTable ? (
              <div
                className={cx('large-12 columns mb20', styles['elss-table'])}
              >
                <Table data={elssComparisonTable} />
                <div className="mt10">
                  *Taxable @ 10% over and above Rs 1 lakh.
                </div>
              </div>
            ) : null}
            <div className="large-12 columns">
              <BlockHeader text={reasons.title} />
              <CheckedTips tips={reasons.reasons} />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default PlanSummary;



// WEBPACK FOOTER //
// ./components/plan/planSummary.tsx